import { render, staticRenderFns } from "./FormControlPagesDisplayInSitemap.vue?vue&type=template&id=45886751"
import script from "./FormControlPagesDisplayInSitemap.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlPagesDisplayInSitemap.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports